import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoFooterComponent } from './go-footer.component';

@NgModule({
  declarations: [
    GoFooterComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GoFooterComponent
  ]
})

export class GoFooterModule { }
